import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';

import { Picture } from '@/components/image/Image';
import { Card } from '@/components/sections/Card';
import { createPlateUI } from '@/lib/create-plate-ui';
import { cn } from '@/lib/utils';
import { Product } from '@/services/api/contracts/catalog/types';
import {
  createBoldPlugin,
  createCodePlugin,
  createItalicPlugin,
  createStrikethroughPlugin,
  createUnderlinePlugin
} from '@udecode/plate-basic-marks';
import { createBlockquotePlugin } from '@udecode/plate-block-quote';
import { Plate, PlateProvider, TEditableProps, Value, createPlugins } from '@udecode/plate-common';
import { createHeadingPlugin } from '@udecode/plate-heading';
import { createParagraphPlugin } from '@udecode/plate-paragraph';
import { FC } from 'react';

const plugins = createPlugins(
  [
    createParagraphPlugin(),
    createBlockquotePlugin(),
    createHeadingPlugin(),

    createBoldPlugin(),
    createItalicPlugin(),
    createUnderlinePlugin(),
    createStrikethroughPlugin(),
    createCodePlugin()
  ],
  {
    components: createPlateUI()
  }
);

interface RichTextInputProps {
  value: Value;
}

const RichText: FC<RichTextInputProps> = ({ value }) => {
  return (
    <PlateProvider plugins={plugins} value={value} readOnly={true}>
      <Plate
        editableProps={
          {
            className: cn('relative max-w-full leading-[1.4] outline-none [&_strong]:font-bold bg-white')
          } as TEditableProps
        }
      />
    </PlateProvider>
  );
};

export const ProductDetailsModal: FC<ModalProps<Product>> = props => {
  return (
    <Modal className="md:max-w-2xl" {...props}>
      <Card className="flex w-full flex-col gap-2 p-10 pb-12">
        <Modal.Controls {...props} />
        {props.props && (
          <div className="flex flex-col gap-3">
            {props.props.imageUri?.id && <Picture image={props.props.imageUri} containerHeight={300} containerWidth={300} />}
            {props.props.description && <RichText value={props.props.description.value} />}
          </div>
        )}
      </Card>
    </Modal>
  );
};
